import { Exchange, Operation } from "urql";
import { fromPromise, fromValue, map, mergeMap, pipe } from "wonka";

/**
 * Inspired by https://community.auth0.com/t/auth0-react-how-to-use-getaccesstokensilently-for-my-urql-auth-exchange/59402/2.
 */
export function fetchOptionsExchange(fn: (fetchOptions: RequestInit) => Promise<RequestInit>): Exchange {
    return ({ forward }) =>
        (ops$) => {
            return pipe(
                ops$,
                mergeMap((operation: Operation) => {
                    const result = fn(operation.context.fetchOptions as never);
                    return pipe(
                        (typeof result.then === "function" ? fromPromise(result) : fromValue(result)) as never,
                        map((fetchOptions: RequestInit | (() => RequestInit)) => ({
                            ...operation,
                            context: { ...operation.context, fetchOptions },
                        })),
                    );
                }),
                forward,
            );
        };
}
